import DocumentsDiskIcon from '@assets/icons/documents-disk.svg?react';
import DocumentsEdoIcon from '@assets/icons/documents-edo.svg?react';
import OrganizationDirectoriesIcon from '@assets/icons/organization-directories.svg?react';
import OrganizationHrIcon from '@assets/icons/organization-hr.svg?react';
import SalesFinancesIcon from '@assets/icons/sales-finance-finances.svg?react';
import SalesIcon from '@assets/icons/sales-finance-sales.svg?react';
import WarehouseLogisticsIcon from '@assets/icons/warehouse-logistics.svg?react';
import WarehouseStorageIcon from '@assets/icons/warehouse-storage.svg?react';
import WorkChatsIcon from '@assets/icons/work-chats.svg?react';
import WorkProjectsIcon from '@assets/icons/work-projects.svg?react';
import WorkTasksIcon from '@assets/icons/work-tasks.svg?react';
import {
  Activity,
  BookOpen,
  Bot,
  CalendarDays,
  ClipboardList,
  FileCode,
  Briefcase,
  Contact,
  Package,
  Phone,
  PieChart,
  Users,
} from 'lucide-react';

import type { SidebarLinkItem, SidebarSection } from './DesktopSidebar.types';

export const navSections: SidebarSection[] = [
  {
    title: 'ОПЕРАЦИОНКА',
    items: [
      // Задачи старого бэка. В этой ветке экран задач — это уже v2, а legacy
      // держим закомментированным, чтобы вернуть одной строкой, если переезд
      // придётся откатить.
      // { icon: WorkTasksIcon, label: 'Задачи', to: '/', end: true },
      { icon: WorkTasksIcon, label: 'Задачи', to: '/tasks-v2' },
      { icon: WorkChatsIcon, label: 'Чаты', to: '/chats' },
      { icon: SalesIcon, label: 'Продажи', to: '/tools/sales' },
      { icon: ClipboardList, label: 'Планирование', to: '/planning' },
      // События календаря нового бэка (/v2/calendar/events).
      { icon: CalendarDays, label: 'События', to: '/events' },
      { icon: Phone, label: 'Звонки', to: '/tools/calls' },
    ],
  },
  {
    title: 'УЧЕТ',
    items: [
      { icon: DocumentsDiskIcon, label: 'Диск', to: '/disk' },
      {
        icon: OrganizationDirectoriesIcon,
        label: 'Справочники',
        to: '#',
        kind: 'directories',
      },
      // Плоские товары нового бэка (/v2/products) — это не каталог
      // «Справочников» на directory_dev, там своя, более богатая модель.
      { icon: Package, label: 'Товары', to: '/products' },
      // CRM нового бэка: чтение из зеркала Bitrix, запись в /v2/crm/*.
      { icon: Contact, label: 'CRM', to: '/crm' },
      { icon: DocumentsEdoIcon, label: 'ЭДО', to: '/edo' },
    ],
  },
  {
    title: 'СКЛАД И ЛОГИСТИКА',
    items: [
      { icon: WarehouseStorageIcon, label: 'Склад', to: '#' },
      {
        icon: WarehouseLogisticsIcon,
        label: 'Логистика',
        to: '/tools/logistics',
      },
    ],
  },
  {
    title: 'AI ASSISTANT',
    items: [
      { icon: FileCode, label: 'AI Files', to: '/tools/ai-files' },
      { icon: Bot, label: 'AI Control', to: '/tools/task-control' },
      { icon: BookOpen, label: 'База знаний', to: '/tools/knowledge-base' },
    ],
  },
  {
    title: 'АНАЛИТИКА',
    items: [
      { icon: Activity, label: 'Операционный пульс', to: '/pulse' },
      { icon: PieChart, label: 'BI-отчеты', to: '/tools/bi' },
      { icon: SalesFinancesIcon, label: 'Финансы', to: '/finance' },
    ],
  },
];

// Раздел «Компания»: Проекты, Отделы (выпадашка с группами), Кадры, Команда.
// Порядок рендера в DesktopSidebarOrganization: [0] → Отделы → [1] → [2].
export const organizationItems: SidebarLinkItem[] = [
  { icon: WorkProjectsIcon, label: 'Проекты', to: '/projects' },
  { icon: OrganizationHrIcon, label: 'Кадры', to: '#' },
  // Объекты нового бэка (/v2/projects) — не путать с дашбордом «Проекты»
  // выше, который сидит на битриксовых смарт-процессах.
  { icon: Briefcase, label: 'Объекты', to: '/projects-v2' },
  // Структура нового бэка: отделы, рабочие группы и их загрузка. Пункт
  // «Отделы» выше — legacy-выпадашка с битриксовыми группами, это другое.
  { icon: Users, label: 'Команда', to: '/team' },
];
